import React from 'react';
import styled from 'styled-components';
import BannerNft from './BannerNft';
import CascadingDropdown from './CascadingDropdown';

import RightBackgroundImage from "../../Images/backgroundImage.jpg";


const Root = styled.div`
 background-image: url(${RightBackgroundImage});
  background-size: cover;
  background-position: center;
  height: 100vh;
`;
const NftMintData = () => {
  return (
  <Root>
    <BannerNft />
    <CascadingDropdown />

  </Root>
  )
}

export default NftMintData